import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";


async function requisicaoPay(rota, dados) {
    if (!JwtService.getToken()) return { resultado: false, erro: "Sessão expirada.", msg: "Entre novamente no Desk." };
    ApiService.setHeader();
    try { return (await ApiService.postOnce(rota, dados)).data; }
    catch (e) {
        const msg = e.response?.data?.erro || e.response?.data?.msg || e.response?.data?.message || "Operação sem confirmação. Consulte a situação antes de repetir.";
        return { resultado: false, erro: msg, msg, REGISTROS: [], QUANTIDADE: 0 };
    }
}

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPayRecebedores(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return requisicaoPay("payRecebedores/access/listar", dados);
    }, 
    getPayRecebedor(context, dados) {
        return requisicaoPay("payRecebedores/access/obter", { ID_PAY_RECEBEDOR: dados.id, componente: dados.componente });
    }, 
    deletePayRecebedor(context, dados) {
        return requisicaoPay("payRecebedores/access/excluir", { ID_PAY_RECEBEDOR: dados.id, componente: dados.componente });
    }, 
    postPayRecebedor(context, dados) {
        return requisicaoPay("payRecebedores/access/salvar", dados);
    }, 
    postPayRecebedorSincronizarAdquirente(context, idPayRecebedor) {
        return requisicaoPay("payRecebedores/access/sincronizarAdquirente", {ID_PAY_RECEBEDOR: idPayRecebedor});
    }, 
    postPayRecebedorObterSaldo(context, idPayRecebedor) {
        return requisicaoPay("payRecebedores/access/obterSaldo", {ID_PAY_RECEBEDOR: idPayRecebedor});
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};